// src/axiosConfig.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token; // 🔥 ini penting
  }
  return config;
});

// ============================================================
// 401 HANDLER
// Kalau token invalid/expired, paksa logout & arahkan ke /login.
// Dipasang di instance `api` (dipakai AuthContext) DAN di axios default
// (dipakai AdminContext/MaintenanceContext/UserContext lewat `import axios`).
// ============================================================
const handle401 = (error) => {
  const status = error.response?.status;
  const path = window.location.pathname;
  // Jangan redirect saat gagal login (user salah password di halaman /login).
  if (status === 401 && path !== "/login") {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
  }
  return Promise.reject(error);
};

api.interceptors.response.use((res) => res, handle401);
axios.interceptors.response.use((res) => res, handle401);

export default api;
